import React from 'react'
import PropTypes from 'prop-types'

import Box from '../../Box'

const Separator = (props) => {
  const { boxProps, children } = props

  return (
    <Box
      alignItems="center"
      backgroundColor="backgroundColor"
      borderTop="1px solid"
      borderBottom="1px solid"
      borderColor="lineColor"
      fontSize="small"
      justifyContent="center"
      marginX="-16px"
      padding="small"
      width="calc(100% + 32px)"
      {...boxProps}
    >
      {children}
    </Box>
  )
}

Separator.propTypes = {
  boxProps: PropTypes.object,
  children: PropTypes.node,
}

export default Separator
